import React from 'react';
import ReactDOM from 'react-dom';
// Internationalization
import { IntlProvider } from 'react-intl';
import Korean from 'lang/compiled/ko.json';
import English from 'lang/compiled/en.json';
import Japanese from 'lang/compiled/ja.json';
// Redux
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// App
import AppContainer from 'redux/container/AppContainer';
import configureStore from 'redux/configureStore';
import { getLocale } from 'util/Utility';
import { disableReactDevTools } from 'util/disableReactDevTools';
import Const from 'constant/Const';

import * as Sentry from '@sentry/react';

const { store, persistor } = configureStore();
const locale = getLocale();

function loadLocaleData(locale) {
  switch (locale) {
    case 'ko':
      return Korean;
    case 'ja':
      return Japanese;
    default:
      return English;
  }
}

if (process.env.REACT_APP_VERCEL_ENV === 'production') {
  disableReactDevTools();
}

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider
      locale={locale}
      defaultLocale={Const.LANGUAGE.KO}
      messages={loadLocaleData(locale)}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Sentry.ErrorBoundary>
            <AppContainer />
          </Sentry.ErrorBoundary>
        </PersistGate>
      </Provider>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
